export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'jobs' as const;

export const RELATIONSHIP_TYPES = {
  ROLE: 'role',
  JOB_POSITION: 'job_position',
  CUSTOM_JOB_POSITION: 'custom_job_position',
} as const;

export const PTO_CATEGORIES = {
  VACATION: 'vacation',
  SICK: 'sick',
  PERSONAL: 'personal',
  OTHER: 'other',
} as const;
